export type TableColumns = TableColumn[];

export class TableColumn {
  translationKey: string;
  class: string;

  constructor(init?: Partial<TableColumn>) {
    Object.assign(this, init);
  }
}
